module.exports = __webpack_public_path__ + "static/media/IMMAF-World-Collage.e0ef9095.svg";